import { render } from "./CurrentDataSummary.vue?vue&type=template&id=22687310"
import script from "./CurrentDataSummary.vue?vue&type=script&lang=js"
export * from "./CurrentDataSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__